import { useContext, useEffect } from "react";
import { Route, useNavigate } from "react-router-dom";
import { Web3Context } from "../contexts/Web3Context";

export default function AuthenticatedRoute({ children }) {
  const navigate = useNavigate();
  const { user } = useContext(Web3Context);
  useEffect(() => {
    // Only require being signed in. The old check also demanded an Ethereum
    // network (networkId 1/5), which redirected Solana accounts home.
    if (!user) {
      navigate("/");
    }
  }, [user]);
  return <>{children}</>;
}
